import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useRouter } from "next/router";

import { Box, Typography, Container, Grid } from "@mui/material";

import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import i18n from "i18next";

// actions
import { getNewsList, getSpecialNews } from "context/actions/news";
import { getRegionList } from "context/actions/region";
import { getLinkList } from "context/actions/link";
import { getPartnerList } from "context/actions/partner";
import { getCoverList } from "context/actions/cover";
import { getYoutubeList } from "context/actions/youtube";
import { getSpecialAlert } from "context/actions/alert";
import { getView, insertView } from "context/actions/view";
import { getServiceList } from "context/actions/service";

// components
import Slider from "components/Slider";
import Organization from "components/Organization";
import Introduction from "components/Introduction";
import Video from "components/Video";
import BestList from "components/BestList";
import NewsTabButton from "components/NewsTabButton";
import NewsItem from "components/NewsItem";
import AlertPopUp from "components/AlertPopUp";
import Views from "components/Views";
import VideoPlayer from "components/VideoPlayer";

const advantages = [
  // {
  //   icon: "/medical-report.png",
  //   label: "Танилцуулга",
  //   size: 35,
  //   route: "info",
  //   more: "Дэлгэрэнгүй",
  // },
  {
    icon: "/icon/doctor.avif",
    label: "Эмч мэргэжилтэнүүд",
    labelEn: "Medical specialists",

    size: 50,
    route: "doctor",
    more: "Дэлгэрэнгүй",
  },
  {
    icon: "/icon/12110712.png",
    label: "Үйлчилгээ",
    labelEn: "Service",
    size: 40,
    route: "outpatient",
    more: "Дэлгэрэнгүй",
  },
  // {
  //   icon: "/icon/12110712.png",
  //   label: "Үйлчилгээ",
  //   size: 40,
  //   route: "service",
  //   more: "Дэлгэрэнгүй",
  // },
];

const sector = [
  {
    icon: "/icon/ambulancelast.png",
    label: "Чих хамар хоолойн өвчлөлийн оношилгоо (ENT)",
    size: 40,
    route: "doctor",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/head.png",
    label: "Толгой хүзүүний мэс заслын оношилгоо эмчилгээ (HNS)",
    size: 40,
    route: "service",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/face.png",
    label: "Нөхөн сэргээх мэс заслууд (Reconstruction surgery)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/blood-pressure.png",
    label:
      "Эмнэлгийн тоног төхөөрөмж ханган нийлүүлэх дагалдах хэрэгсэл (Medical instruments service)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/facial-massage.png",
    label: "Гоо сайхны мэс заслууд (Plastic surgery)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/treatment.png",
    label: "Өдрийн эмчилгээ (Day care unit)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/earl.png",
    label: "Сонсгол судлал (Audiology)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/emotion.png",
    label: "Тэнцвэр судлал (Vestibular clinic)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
  {
    icon: "/icon/audiologyl.png",
    label: "Сонсголын аппарат тохируулга (Hearing aid service)",
    size: 40,
    route: "about",
    more: "Дэлгэрэнгүй",
    bgColor: "#fff",
    color: "#212F3D",
  },
];

const HomePage = ({}) => {
  const { t } = useTranslation();
  const router = useRouter();

  const [specialNews, setSpecialNews] = useState([]);
  const [allNews, setAllNews] = useState([]);
  const [timeNews, setTimeNews] = useState([]);
  const [videoNews, setVideoNews] = useState([]);
  const [photoNews, setPhotoNews] = useState([]);
  const [warningNews, setWarningNews] = useState([]);
  const [link, setLink] = useState([]);
  const [partner, setPartner] = useState([]);
  const [cover, setCover] = useState([]);
  const [youtube, setYoutube] = useState([]);
  const [alert, setAlert] = useState(null);
  const [viewData, setView] = useState(null);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    const resANews = await getNewsList("", 1, 3, "", 1);
    if (resANews.status === "success") setAllNews(resANews.data.list);

    const resSNews = await getSpecialNews();
    if (resSNews.status === "success") setSpecialNews(resSNews.data.list);
    const resLink = await getLinkList();
    if (resLink.status === "success") setLink(resLink.data);
    const resPartner = await getPartnerList();
    if (resPartner.status === "success") setPartner(resPartner.data);
    const resCover = await getCoverList();
    if (resCover.status === "success") setCover(resCover.data);
    const resYoutube = await getYoutubeList();
    if (resYoutube.status === "success") setYoutube(resYoutube.data);
    const resAlert = await getSpecialAlert();
    if (resAlert.status === "success") setAlert(resAlert.data);
    const resViewInsert = await insertView();
    const resView = await getView();
    if (resView.status === "success");
    setView(resView.data);

    const res = await getServiceList();
    if (res.status === "success") {
      setDepartments(res.data);
    }
  };

  const closeAlert = () => {
    setAlert(null);
  };

  const handleClick = (route) => {
    router.push(`/${route}`);
  };

  const handleCardClick = (id) => {
    router.push(`/service/${id}`);
  };

  return (
    <Container maxWidth={false} disableGutters={true} className="bg-[#f5f6fa]">
      <Container maxWidth={"lg"} id={"advantage"}>
        <Slider linkData={cover} />
      </Container>

      <Container maxWidth="lg" id="advantage" className="w-full">
        <Box className="grid py-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
          {advantages.map((item, index) => (
            <Box
              key={index}
              onClick={() => handleClick(item.route)}
              className="border px-4 py-4 rounded-lg flex  items-center gap-4 bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
            >
              <Box>
                <Image
                  width={item.size}
                  height={item.size}
                  src={item.icon}
                  alt={item.label}
                  // className="rounded-full"
                  style={{ objectFit: "cover" }}
                />
              </Box>
              <Box className="text-[16px] font-semibold text-[#212F3D]">
                {i18n.language === "en" ? item.labelEn : item.label}

                <Box className="text-[16px] font-normal flex justify-end text-[blue]">
                  {/* {item.more} */}
                </Box>
              </Box>
              {/* <Box>
                <Image
                  width={20}
                  height={20}
                  src={"/icon/menu.png"}
                  alt={item.label}
                  className="rounded-full"
                  style={{ objectFit: "cover" }}
                />
              </Box> */}
            </Box>
          ))}
        </Box>
      </Container>

      <div
        style={{
          // backgroundImage: "url(/31.jpg)",
          height: "auto",
          backgroundSize: "contain",
          paddingTop: 50,
          paddingBottom: 55,
          marginTop: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          backgroundColor: "#212F3D",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        }}
      >
        <Container maxWidth={"lg"} style={{ textAlign: "" }} id={"advantage"}>
          <Box className="w-full text-center">
            <Typography
              variant="h2"
              fontWeight="bold"
              color="#fff"
              textAlign="center"
              mb={4}
            >
              {/* {t("main_direction")} */}

              {i18n.language === "en" ? "Main direction" : "Үндсэн чиглэл"}
            </Typography>
          </Box>
          <Box className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {sector.map((item, index) => (
              <Box
                key={index}
                // onClick={() => handleClick(item.route)}
                className="p-4 rounded-xl flex items-center justify-between cursor-pointer shadow hover:shadow-md transition-all"
                sx={{
                  backgroundColor: item.bgColor || "#f0f0f0",
                  color: item.color || "#000",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box className="flex items-center justify-between gap-4">
                  <Image
                    width={item.size || 40}
                    height={item.size || 40}
                    src={item.icon}
                    alt={item.label}
                    style={{ objectFit: "cover" }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: item.color,
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Container>
      </div>
      <Box className="w-full text-center">
        <Typography
          variant="h2"
          fontWeight="bold"
          color="#212F3D"
          textAlign="center"
          mt={4}
          mb={2}
        >
          {i18n.language === "en" ? "News" : "Мэдээ мэдээлэл"}
        </Typography>
      </Box>
      <div
        style={{
          marginTop: 30,
          backgroundColor: "#f5f6fa",
          paddingTop: 10,
          paddingBottom: 50,
        }}
      >
        <Container
          maxWidth={"lg"}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          id={"advantage"}
        >
          <Grid container spacing={4} direction={"row"}>
            {allNews.map((item, ind) => {
              return (
                <Grid key={ind} item lg={4} md={4} sm={6} xs={12}>
                  <NewsItem
                    key={ind}
                    newsId={item.id}
                    imageUrl={item.imageUrl}
                    date={item.createdAtDay}
                    name={i18n.language === "en" ? item.nameEng : item.name}
                    description={
                      i18n.language === "en"
                        ? item.descriptionEng
                        : item.description
                    }
                    last={allNews.length === ind + 1 ? true : false}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth={false}
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f6fa",
        }}
        id={"advantage"}
      >
        {/* <Video linkData={youtube} /> */}
        <BestList linkData={link} />
      </Container>

      {/* <Container
        maxWidth={"xxl"}
        style={{
          display: "flex",
          flexDirection: "column",
          background: "#f5f6fa",
        }}
        id={"advantage"}
      >
        <Organization linkData={partner} />
      </Container> */}
      <Container
        maxWidth={"lg"}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        id={"advantage"}
      >
        <Views viewValue={viewData} />
      </Container>

      {alert && alert.imageUrl && (
        <AlertPopUp open={true} handleClose={closeAlert} alert={alert} />
      )}
    </Container>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
